export const GET_LICENSES = `query getLicenses{
    getLicenses{name,id,link,category}
  }`;
export const GET_DATALAB = `
  query getDatalab($datalab: ID!){
    lab: getDatalab(datalab_id: $datalab) {
      id name description icon status repository, artefact, branch, owner{displayName,username},modified_at,created_at, version
      metadata{name value, definition {
        required
        sensitive
        recommended
        description
          type
          visibility
          owner
        pattern
        errorMessage
      }} is_public
      nstars
    }

    builds: getDatalabBuilds(datalab_id: $datalab) {
      version, id, created_at, status, progress, logs, buildRef,scanRef, runtimeConfiguration {cpuAllocation memAllocation}
    }
  }
  `;
export const SCAN_DATALAB_BUILD = `
    mutation scanDatalabBuild($build: ID!) {
      scanDatalabBuild(
        build: $build
      ) { id scanRef }
    }
  `;
export const GET_BUILD = `
  query getBuild($id: ID) {
    build: getBuilds(id: $id) {
      version, datalabId, id, created_at, status, logs, progress, buildRef, scanRef, runtimeConfiguration {cpuAllocation memAllocation}
    }
  }`;
export const EXTRACT_DATALAB_METADATA = `query extractDatalabMetadata($lab: ID!){
    extractDatalabMetadata(datalab: $lab) {
      name,value, definition {
        description,type,visibility,owner,required,sensitive,recommended,pattern,errorMessage
         }
    }
  }`;
export const CREATE_DATALAB = `mutation {createDatalabClass}`;
export const SET_DATALAB_REPOSITORY = `mutation setDatalabRepository($datalab: ID!, $repository: String!, $branch: String) {
    setDatalabRepository(datalab: $datalab, repository: $repository, branch: $branch)
  }`;
export const SET_DATALAB_TYPE = `mutation setDatalabType($datalab: ID!, $type: String!) {
    setDatalabType(datalab: $datalab, type: $type)
  }`;
export const SET_DATALAB_CLUSTERS = `mutation setDatalabClusters($datalab: ID!, $clusterIds: [ID!]!) {
    setDatalabClusters(datalab: $datalab, cluster_ids: $clusterIds)
  }`;
export const REMOVE_DATALAB = `mutation removeDatalab($datalab: ID!) {
    removeDatalab(
        datalab: $datalab,
    ) {id name}
  }`;
export const GET_DATALAB_BUILDS = `query getBuilds($id: ID, $qs: String) {
    getBuilds(id: $id, qs: $qs) {
      version
    }
  }`;
export const SET_LAB_METADATA_ENTRIES = `mutation setDatalabMetadataEntries($datalab: ID!, $entries: [MetadataEntryInput!]!) {
    setDatalabMetadataEntries(
        datalab: $datalab
        entries: $entries
    ) { id }
  }`;
export const BUILD_DATALAB = `mutation buildLab($datalab: ID!) {
    buildDatalab(
      datalab: $datalab,
    ) {id,buildRef,progress}
  }`;
export const ALL_DATALABS_BUILDS_BOOKMARKS_INSTANCES = `query all_datalabs_builds_bookmarks_instances($qs: String, $clusterId: ID) {
    datalabs: getDatalabs(qs: $qs, cluster_id: $clusterId) {
      id, name, nstars, icon, description,created_at,created_at, modified_at, status, is_public, owner{username}, metadata{name,value}
    }

    builds: getBuilds(qs: $qs) {
      id, datalabId, version, status, created_at, progress, buildRef, scanRef
    }

    bookmarkedBuilds: getBookmarks {
      datalab
    }

    runningInstances: datalabs(clusterId: $clusterId) {
      id dlp{ id name description config version } name state secret clusterId
      resources{id state, type,specification}
      categories
    }
  }
  `;
export const SEARCH_DATALABS = `query all_datalabs_builds_bookmarks_instances($qs: String, $clusterId: ID) {
    datalabs: getDatalabs(qs: $qs, cluster_id: $clusterId) {
      id, name, nstars, icon, description,created_at, modified_at, status, is_public, owner{username}, metadata{name,value}
    }

    builds: getBuilds(qs: $qs) {
      id, datalabId, version, status, created_at, progress, buildRef, scanRef
    }
  }
  `;
export const SET_BOOKMARK = `mutation bookmarkBuild($build: ID!, $bookmarked: Boolean!) {
    bookmarkBuild(
      build: $build
      bookmarked: $bookmarked
    )
  }`;
export const SEARCH_USERS = `query search_users($name: String) {
    users: searchUser(name: $name) {
      username, displayName
    }
  }
  `;
export const COMMENT_DATALAB = `
mutation commentDatalab($datalab: ID!, $comment: String) {
  commentDatalab(
    datalab: $datalab,
    comment: $comment
  )
}`;
export const GET_DATALAB_COMMENTS = `
  query getDatalabComments($datalab: ID!) {
    getDatalabComments(
      datalab: $datalab
    ){
      datalab_id
      build_version
      modified_at
      comment
      user{
        displayName
        username
      }
    }
  }`;
export const PUBLISH_DATALAB_BUILD = `mutation publishBuild($build: ID!) {
    publishBuild(build: $build)
  }
  `;
export const UNPUBLISH_DATALAB_BUILD = `mutation revokeBuildModerationRequest($build: ID!) {
    revokeBuildModerationRequest(build: $build)
  }
  `;
export const ARCHIVE_DATALAB_BUILD = `mutation archiveBuild($build: ID!){
    archiveBuild(build: $build)
  }
  `;
export const UNARCHIVE_DATALAB_BUILD = `mutation unarchiveBuild($build: ID!){
    unarchiveBuild(build: $build)
  }
  `;
export const VALIDATE_DATALAB_BUILD = `mutation validateBuild($build: ID!, $valid: Boolean, $comment: String) {
    validateBuild(build: $build, valid: $valid, comment:$comment)
  }
  `;
export const GET_DATALAB_ACCESS_LIST = `
  query getDatalabAccessList($datalabId: ID!) {
    getDatalabAccessList(datalab_id: $datalabId){
      username, displayName
    }
  }
  `;
export const GRANT_ACCESS = `
  mutation grantAccess($datalabId: ID!, $userId: String!) {
    grantAccess(datalabId: $datalabId, userId: $userId)
  }
  `;
export const REVOKE_ACCESS = `
  mutation revokeAccess($datalabId: ID!, $userId: String!) {
    revokeAccess(datalabId: $datalabId, userId: $userId)
  }
  `;
export const CREATE_DATALAB_INSTANCE_MUTATION = `
  mutation createDatalabInstance($input: CreateDatalabInput!) {
    createDatalabInstance(input: $input) { id,launchRef,name,state, dlp{ id name description config version }, resources { id state, type, specification }}
  }`;
export const DESTROY_DATALAB_MUTATION = `
  mutation destroyDatalab($id: ID!) { destroyDatalab(id: $id) }
  `;
